import { useState } from "react";
import { memes } from "@/mocks/fun";
import Reveal from "@/components/base/Reveal";

export default function MemeGallery() {
  const [toast, setToast] = useState("");

  const copyText = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      /* ignore */
    }
    setToast(`文案已复制：${text}`);
    window.setTimeout(() => setToast(""), 1800);
  };

  return (
    <section id="memes" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1240px] px-4 md:px-6">
        <Reveal>
          <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
            <div>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1.5 text-xs font-semibold text-accent-800">
                <i className="ri-emotion-laugh-fill"></i> 栏目·表情包收割机
              </span>
              <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">关键时刻，一张图顶十句话</h2>
              <p className="mt-2 max-w-2xl text-sm text-foreground-600 md:text-base">
                点击卡片即可复制下方文案，表情包自行保存。聊天战场从此没人能赢过你。
              </p>
            </div>
          </div>
        </Reveal>

        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {memes.map((m, i) => (
            <Reveal key={m.id} delay={(i % 4) * 50}>
              <button
                onClick={() => copyText(m.caption)}
                className="group flex w-full flex-col overflow-hidden rounded-2xl bg-background-50 text-left transition-transform duration-200 hover:-translate-y-1"
                aria-label={`复制表情包文案 ${m.caption}`}
              >
                <div className="relative overflow-hidden">
                  <img
                    src={m.src}
                    alt={`表情包配图：${m.caption}`}
                    className="aspect-square w-full object-cover transition-transform duration-300 group-hover:scale-105"
                  />
                  <span className="absolute right-2 top-2 grid h-8 w-8 place-items-center rounded-full bg-background-50/90 text-foreground-600 opacity-0 transition-opacity group-hover:opacity-100">
                    <i className="ri-file-copy-line"></i>
                  </span>
                </div>
                <div className="flex items-center gap-2 px-3 py-3">
                  <span className="min-w-0 flex-1 truncate font-heading text-sm text-foreground-900 md:text-base">{m.caption}</span>
                  <i className="ri-mouse-fill shrink-0 text-foreground-300"></i>
                </div>
              </button>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <p className="mt-7 text-center text-xs text-foreground-500">
            共有 <span className="font-semibold text-foreground-700">12w+</span> 张表情包持续上新 · 用图小贴士：表情包仅供娱乐，请勿用于恶意嘲讽或人身攻击
          </p>
        </Reveal>
      </div>

      {toast && (
        <div className="fixed bottom-6 left-1/2 z-[60] -translate-x-1/2 animate-modal rounded-full bg-foreground-950 px-5 py-2.5 text-sm font-medium text-background-50 shadow-lg">
          {toast}
        </div>
      )}
    </section>
  );
}